// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falArrowDownLeftAndArrowUpRightToCenter: CreateIconOptions = {
  "displayName": "FALArrowDownLeftAndArrowUpRightToCenter",
  "viewBox": "0, 0, 512, 512",
  "d": "M507.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 169.4 320 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 8.8 7.2 16 16 16l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-105.4 0L507.3 27.3zM4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 342.6 192 448c0 8.8 7.2 16 16 16s16-7.2 16-16l0-144c0-8.8-7.2-16-16-16L64 288c-8.8 0-16 7.2-16 16s7.2 16 16 16l105.4 0L4.7 484.7z"
};
